import React from "react";
import LogoSpinner from "./LogoSpinner";

const RouteLoadingScreen = () => (
  <div className="app-route-loading" role="status" aria-label="Loading Hoarding Life">
    <LogoSpinner size={40} />
  </div>
);

export default React.memo(RouteLoadingScreen);
